
import { PackageOption } from '../../types/packageTypes';

export const packageOptions: PackageOption[] = [
  {
    id: 'freemium',
    title: 'Google Business Profile Optimization',
    price: 'Free',
    features: [
      'Business profile setup',
      'Local SEO optimization',
      'Review management',
      'Basic analytics'
    ],
    borderColor: 'border-blue-500',
    buttonColor: 'bg-blue-500 hover:bg-blue-600',
    tier: 1
  },
  {
    id: 'landing-pages',
    title: 'Instant Business Website',
    price: '$197/mo',
    features: [
      'Everything in Free tier',
      'Custom website',
      'Mobile responsive design',
      'Lead capture forms',
      'Performance analytics'
    ],
    borderColor: 'border-yellow-500',
    buttonColor: 'bg-yellow-500 hover:bg-yellow-600',
    tier: 2
  },
  {
    id: 'google-ads',
    title: 'Google Ads Automation + Website',
    price: '$197/mo',
    originalPrice: '$497/mo',
    features: [
      'Everything in Website tier',
      'Google Ads setup & management',
      'Keyword research & optimization',
      'Conversion tracking',
      'Monthly performance reports'
    ],
    borderColor: 'border-green-500',
    buttonColor: 'bg-green-500 hover:bg-green-600',
    tier: 3
  }
];
